import type { LiveEvent } from '@setplex/tria-api'
import type { EventWithPrice } from '~/shared/interfaces'

import { EventStatus } from '@setplex/tria-api'
import { exists } from '~/shared/helpers'
import { formatDateDuration, timeWithin } from '~/shared/helpers/date'
import { extendLiveEventByLabelPrice } from '~/shared/tools'

export const formatLiveEventWithPrice = (
  liveEvent: LiveEvent
): EventWithPrice => extendLiveEventByLabelPrice(liveEvent)

export const formatPastEventWithPrice = (liveEvent: LiveEvent) => {
  const duration =
    exists(liveEvent.startTime) && exists(liveEvent.endTime)
      ? timeWithin(new Date(liveEvent.endTime), new Date(liveEvent.startTime))
      : undefined

  const withPrice: EventWithPrice = {
    ...formatLiveEventWithPrice(liveEvent),
    formattedStartTime: duration
      ? formatDateDuration({
          duration,
          short: true,
        })
      : undefined,
  }

  return withPrice
}

export const formatLiveEventCardWithPrice = (
  liveEvent: LiveEvent
): EventWithPrice =>
  liveEvent.status === EventStatus.ENDED
    ? formatPastEventWithPrice(liveEvent)
    : formatLiveEventWithPrice(liveEvent)
